export default function () {
  $('#deployment_environment').change(updateEnvironment);

  function updateEnvironment() {
    const envId = $('#deployment_environment').val();
    if (!envId) {
      return;
    }
    $.ajax({
      url: '/api/deployment-environments/'+envId,
      type: 'get',
      success: (data) => {
        $('.data-env-name').text(data.name);
        $('.data-template-hcl').text(data.template.hcl);
        $('.data-template-slug').text(data.template.slug);
        $('.data-template-updated').text(data.template.updatedAt);
        $('#deployment_gitBranch').val(data.defaultGitBranch);
      }
    });
  }

  updateEnvironment();
};



// WEBPACK FOOTER //
// ./assets/js/deploy.js